import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({

    apiKey: "AIzaSyCj3zF8N3wW_Y_qqznZmrM3lu-DDyD3wHQ",
    authDomain: "facebook-messenger-1-f01d0.firebaseapp.com",
    databaseURL: "https://facebook-messenger-1-f01d0.firebaseio.com",
    projectId: "facebook-messenger-1-f01d0",
    storageBucket: "facebook-messenger-1-f01d0.appspot.com",
    messagingSenderId: "508589666282",
    appId: "1:508589666282:web:09a9bf6795f9792002cc93",
    measurementId: "G-G3HRWRLM7B"
});

const db = firebaseApp.firestore();

export default db;